import React from 'react';
import { ThemeProvider } from '@kufox/mui';
import remoteEvent from '@tools/remoteEvent';
import useConstructor from '@hooks/useConstructor';
import { extendModel } from '@utils';
import uniqueModel from '@tools/uniqueModel';
import headerModel from './model';
import cmscomsHeaderModel from '../CmsComs/model';
import Header from './Header';

export default (props) => {
  useConstructor(() => {
    remoteEvent.emit(remoteEvent.evts.GET_DVA, (dva, m) => {
      uniqueModel(dva, extendModel(m, headerModel));
      uniqueModel(dva, extendModel(m, cmscomsHeaderModel));
    });
  });
  return (
    <ThemeProvider theme={props.theme || 'light'}>
      <Header {...props} />
    </ThemeProvider>
  );
};
